import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GH_COLORS } from '../components/Style';

export default function DummyPage({ title, description }: { title: string; description: string }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        backgroundColor: GH_COLORS.canvas,
      }}
    >
      <div
        style={{
          textAlign: 'center',
          padding: '48px 24px',
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
        }}
      >
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>🚧</div>
        <h1
          style={{
            fontSize: '28px',
            fontWeight: 700,
            color: GH_COLORS.fgDefault,
            marginBottom: '12px',
          }}
        >
          {title}
        </h1>
        <p
          style={{
            fontSize: '16px',
            color: GH_COLORS.fgMuted,
            marginBottom: '32px',
            lineHeight: '1.6',
          }}
        >
          {description}
        </p>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: '10px 24px',
            backgroundColor: GH_COLORS.btnPrimaryBg,
            color: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600,
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
          뒤로 가기
        </button>
      </div>
    </div>
  );
}
